module.exports = __webpack_public_path__ + "static/media/hackcovid-logo.ffabfed2.jpg";